import { toast, type ExternalToast } from "sonner";

const baseToastOptions: ExternalToast = {
  unstyled: true,
  classNames: {
    toast: "app-toast group",
    title: "app-toast-title",
    description: "app-toast-description",
    actionButton: "app-toast-action",
    cancelButton: "app-toast-cancel",
    closeButton: "app-toast-close",
  },
};

function withBase(options?: ExternalToast): ExternalToast {
  return {
    ...baseToastOptions,
    ...options,
    classNames: {
      ...baseToastOptions.classNames,
      ...options?.classNames,
    },
  };
}

function goToLogin() {
  window.location.assign("/login");
}

/** Site-wide notifications · use instead of `alert()` or raw `toast`. */
export const notify = {
  success(message: string, options?: ExternalToast) {
    return toast.success(message, withBase(options));
  },

  error(message: string, options?: ExternalToast) {
    return toast.error(message, withBase(options));
  },

  info(message: string, options?: ExternalToast) {
    return toast.info(message, withBase(options));
  },

  warning(message: string, options?: ExternalToast) {
    return toast.warning(message, withBase(options));
  },

  /** Shown when a signed-in user is required (favorites, bids, etc.). */
  loginRequired(options?: ExternalToast) {
    return toast.error("يرجى تسجيل الدخول أولاً", {
      ...withBase(options),
      duration: options?.duration ?? 6000,
      action: options?.action ?? {
        label: "تسجيل الدخول",
        onClick: goToLogin,
      },
    });
  },
};
